import { Helper } from '@/mixin/helper'
import store from '@/state/store'
const hasAccess = store.getters['identity/hasAccess']

export const allMenu = [
  {
    id: 1,
    label: 'menuitems.menu.text',
    isTitle: true,
    isShow: true,
    isHasAccess: () => {
      return true
    },
  },
  {
    id: 2,
    label: 'menuitems.dashboards.text',
    link: '/',
    icon: 'icon-outline_browser',
    isShow: true,
    isHasAccess: () => {
      return false
    },
  },
  {
    id: 3,
    label: 'menuitems.transaction.text',
    isTitle: true,
    isShow: true,
    isHasAccess: () => {
      return false
    },
  },
  {
    id: 7,
    label: 'menuitems.manageDomain.text',
    icon: 'icon-outline_globe',
    link: '/domain/',
    isShow: Helper.methods.getAccessRight('manageDomain'),
    isHasAccess: () => {
      return hasAccess([
        'sms-md-company:create',
        'sms-md-company:read',
        'sms-md-company:update',
        'sms-md-company:delete',
      ])
    },
  },
  {
    id: 22,
    label: 'menuitems.reportDashboard.text',
    icon: 'icon-outline_trending-up',
    link: '/report-dashboard/',
    isShow: Helper.methods.getAccessRight('report-dashboard'),
    isHasAccess: () => {
      return hasAccess([
        'device-status-log:create',
        'device-status-log:read',
        'device-status-log:update',
        'device-status-log:delete',
      ])
    },
  },
  {
    id: 11,
    label: 'menuitems.qcDevice.text',
    icon: 'icon-outline_submitted',
    link: '/qcdevice/',
    isShow: Helper.methods.getAccessRight('qcDevice'),
    isHasAccess: () => {
      return hasAccess([
        'sms-device-setting:create',
        'sms-device-setting:read',
        'sms-device-setting:update',
        'sms-device-setting:delete',
        'sms-device-register:create',
        'sms-device-register:read',
        'sms-device-register:update',
        'sms-device-register:delete',
      ])
    },
  },
  {
    id: 18,
    label: 'menuitems.masterData.text',
    icon: 'icon-outline_grid',
    link: '/master/',
    isShow: Helper.methods.getAccessRight('masterData'),
    isHasAccess: () => {
      return hasAccess([
        'sms-md-user:create',
        'sms-md-user:read',
        'sms-md-user:update',
        'sms-md-user:delete',
        'sms-md-device:create',
        'sms-md-device:read',
        'sms-md-device:update',
        'sms-md-device:delete',
        'sms-md-vehicle:create',
        'sms-md-vehicle:read',
        'sms-md-vehicle:update',
        'sms-md-vehicle:delete',
      ])
    },
  },
  {
    id: 19,
    label: 'menuitems.workOrder.text',
    icon: 'icon-outline_truck-maintenance',
    link: '/work-order/',
    isShow: Helper.methods.getAccessRight('workOrder'),
    isHasAccess: () => {
      return hasAccess([
        'sms-wo-tracking:create',
        'sms-wo-tracking:read',
        'sms-wo-tracking:update',
        'sms-wo-tracking:delete',
        'sms-wo-validation:create',
        'sms-wo-validation:read',
        'sms-wo-validation:update',
        'sms-wo-validation:delete',
        'sms-wo-timelog:create',
        'sms-wo-timelog:read',
        'sms-wo-timelog:update',
        'sms-wo-timelog:delete',
      ])
    },
  },
  {
    id: 20,
    label: 'menuitems.onlineCommandSetting.text',
    icon: 'icon-outline_code',
    link: '/online-command-setting/',
    isShow: true,
    isHasAccess: () => {
      return hasAccess([
        'online-command-settings:read',
        'online-command-settings:create',
        'online-command-settings:delete',
      ])
    },
  },
  {
    id: 23,
    label: 'menuitems.planner.text',
    icon: 'icon-outline_book',
    link: '/planner/',
    isShow: true,
    isHasAccess: () => {
      return hasAccess([
        'sms-planner-wo-board:read',
        'sms-planner-calendar-schedule:read',
        'sms-planner-technicians:read',
        'sms-planner-package:read',
      ])
    },
  },
  {
    id: 21,
    label: 'menuitems.guideline.text',
    icon: 'icon-outline_book',
    link: '/guideline/',
    isShow: true,
    isHasAccess: () => {
      return hasAccess([
        'sms-guideline:read',
      ])
    },
  },
]
